import React, { ReactElement, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { StatsService } from "../../stats";

export const CASubscribersGauge = (props: any): ReactElement => {
	const [subscribers, setSubscribers] = useState(0);
	const statsService = new StatsService();

	useMemo(() => {
		const fetchSubscribers = async () => {
			const subscriberStats = await statsService.findCaSubscribers(
				props.date,
			);
			setSubscribers(subscriberStats.count);
		};

		fetchSubscribers();
	}, [props.date]);

	return (
		<div className="text-center">
			<h1>CA Subscribers Goal</h1>
			<Chart
				options={{
					chart: {
						type: "radialBar",
						offsetY: -20,
						sparkline: {
							enabled: true,
						},
					},
					plotOptions: {
						radialBar: {
							startAngle: -90,
							endAngle: 90,
							track: {
								background: "#edebec",
								strokeWidth: "97%",
								margin: 5,
							},
							dataLabels: {
								name: {
									show: false,
								},
								value: {
									fontSize: "32px",
									offsetY: -10,
									formatter: () => {
										return "" + subscribers;
									},
								},
							},
						},
					},
					grid: {
						padding: {
							top: -10,
						},
					},
					labels: ["" + subscribers],
				}}
				series={[subscribers / 80]}
				type="radialBar"
			/>
		</div>
	);
};
